import { render } from "./createForm.vue?vue&type=template&id=95070184"
import script from "./createForm.vue?vue&type=script&lang=js"
export * from "./createForm.vue?vue&type=script&lang=js"

import "./createForm.vue?vue&type=style&index=0&id=95070184&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__